import React from 'react';
import {Link} from 'react-router-dom';
import {Box, Button, Typography} from "@mui/material";
import {useNavigation} from "../NavigationProvider";
import forest from "../images/notFound.jpg";
import {useLanguage} from "../LanguageContext";

const NotFound = () => {
    const {handleNavigation} = useNavigation();
    const {t} = useLanguage();

    const handleGoHome = () => {
        handleNavigation('/'); // Navigate to the home page
    };
    return (

        <Box
            sx={{
                width: '100%',
                height: '85vh', // Full viewport height
                backgroundImage: `url(${forest})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                textAlign: 'center',
                color: 'white',
                fontWeight: 'bold',
                padding: 2,
            }}
        >
            <Typography variant="h4" sx={{
                fontFamily: 'Merriweather',
                fontSize: '4rem',
                mb: 2 }}>
                {t('label_not_found')}
            </Typography>
            <Button
                onClick={handleGoHome}
                sx={{
                    color: 'white', // White text color
                    textTransform: 'none', // Remove text transformation (default is uppercase)
                    fontSize: '2rem',
                    backgroundColor: 'transparent', // No background
                    border: 'none', // No border
                    '&:hover': {
                        backgroundColor: 'transparent', // Ensure no hover background
                        textDecoration: 'underline', // Underline on hover to mimic a link
                    }
                }}
            >
                {t('label_back_home')}
            </Button>
        </Box>
    );
}

export default NotFound;
